import { createSelector, createFeatureSelector } from '@ngrx/store';

import * as fromReducer from '@app/store/reducers/bus-companies.reducer';
import { BusCompaniesState } from '@app/store/reducers/bus-companies.reducer';

export const busCompaniesState = createFeatureSelector<BusCompaniesState>('busCompanies');

export const selectBusCompaniesEntities = createSelector(
  busCompaniesState,
  fromReducer.selectEntities
);
